import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { injectIntl, FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import classNames from 'classnames';
import { IconChevronRight } from '../../components';

import css from './BookingPanel.css';

const BookingPanel = props => {
  const { currentListing, intl, history, className } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  const price = currentListing.attributes.price;
  const minDuration = currentListing.attributes.minDurationMonths || 1;
  const listingId = currentListing.id?.uuid;

  const availableAmount = currentListing.attributes.availableAmount;
  const isOutOfStock = availableAmount === 0;

  const totalInitialAmount = price.amount * minDuration;
  const totalInitialPrice = { ...price, amount: totalInitialAmount };

  const onCheckout = () => {
    if (isOutOfStock) return;
    history.push(`/subcheckout/${listingId}`);
  };

  return (
    <div className={classNames(css.root, className)}>
      <div className={classNames(css.subscriptionPanel, { [css.isExpanded]: isExpanded })}>

        <div className={css.mainInfoRow}>
          <div className={css.priceSection}>
            <div className={css.priceWrapper}>
              <span className={css.priceValue}>{formatMoney(intl, price)}</span>
              <span className={css.perMonth}>
                <FormattedMessage id="BookingPanel.perMonth" />
              </span>
            </div>
          </div>

          <div className={css.minDurationSection}>
            <div className={css.minDurationBadge}>
              <FormattedMessage
                id="BookingPanel.minDuration"
                values={{ count: minDuration }}
              />
            </div>
          </div>
        </div>

        {/* ROZWIJALNA SEKCJA PAYMENT NOTICE */}
        {!isOutOfStock && (
          <div className={css.collapsibleSection}>
            <button
              className={css.toggleNoticeBtn}
              onClick={() => setIsExpanded(!isExpanded)}
            >
              <FormattedMessage id={isExpanded ? "BookingPanel.hideNotice" : "BookingPanel.showNotice"} />
              <IconChevronRight className={classNames(css.chevron, { [css.chevronUp]: isExpanded })} />
            </button>

            {/* <div className={css.paymentNoticeWrapper}>
              <div className={css.paymentNotice}>
                <p>
                  <FormattedMessage
                    id="BookingPanel.paymentNotice"
                    values={{
                      duration: minDuration,
                      durationLabel: (
                        <FormattedMessage
                          id="BookingPanel.durationLabel"
                          values={{ count: minDuration }}
                        />
                      ),
                      amount: <span className={css.noticeAmount}>{formatMoney(intl, totalInitialPrice)}</span>,
                      days: 7
                    }}
                  />
                </p>
              </div>
            </div> */}
            <div className={css.paymentNoticeWrapper}>
              <div className={css.paymentNotice}>
                <div className={css.noticeHeader}>
                  <strong>
                    <FormattedMessage id="BookingPanel.paymentNoticeTitle" defaultValue="Jak działają opłaty?" />
                  </strong>
                </div>

                <ul className={css.noticeList}>
                  <li>
                    <FormattedMessage
                      id="BookingPanel.paymentInitialInfo"
                      values={{
                        amount: <strong>{formatMoney(intl, totalInitialPrice)}</strong>,
                        duration: minDuration,
                      }}
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id="BookingPanel.paymentNextInfo"
                      values={{
                        amount: <strong>{formatMoney(intl, price)}</strong>,
                        duration: minDuration,
                      }}
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id="BookingPanel.paymentInfo"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}

        <button
          className={classNames(css.checkoutBtn, isOutOfStock && css.checkoutBtnDisabled)}
          onClick={onCheckout}
          disabled={isOutOfStock}
        >
          {isOutOfStock ? (
            <FormattedMessage id="BookingPanel.outOfStockButton" />
          ) : (
            <FormattedMessage id="BookingPanel.ctaButton" />
          )}
        </button>

        {isOutOfStock && (
          <p className={css.outOfStockNotice}>
            <FormattedMessage id="BookingPanel.outOfStockNotice" />
          </p>
        )}
      </div>
    </div>
  );
};

export default compose(withRouter, injectIntl)(BookingPanel);